// extracted by mini-css-extract-plugin
module.exports = {"close_box":"FJClose_close_box__3TKPg","rotateclosehover":"FJClose_rotateclosehover__317_t"};